import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M28 8H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3v4a1 1 0 1 0 2 0v-4h14v4a1 1 0 0 0 2 0v-4h3a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2m0 8.086L21.914 10H28zM10.086 10l9 9h-6.172L4 10.086V10zM4 12.914 10.086 19H4zM28 19h-6.086l-9-9h6.172L28 18.915z"
    />
  </svg>
);
const SvgIconBarricade = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconBarricade);
export default Memo;
